import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useOrganization } from "@clerk/clerk-react";
import { client, handleClientMethod } from "../client";

export const useUpdateCustomPart = () => {
  const { organization } = useOrganization();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      customPartId,
      data,
    }: {
      customPartId: string;
      data: { cost?: number; title?: string };
    }) => {
      return await handleClientMethod(
        client.PATCH("/api/custom-parts/{id}", {
          params: {
            path: {
              id: customPartId,
            },
          },
          body: data,
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/api/custom-parts", organization?.id],
      });
    },
  });
};
